import { render, staticRenderFns } from "./MaintainerUsers.vue?vue&type=template&id=3b18c948&scoped=true&"
import script from "./MaintainerUsers.vue?vue&type=script&lang=js&"
export * from "./MaintainerUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b18c948",
  null
  
)

export default component.exports